import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store/Auth/GatewayStore';
import SilvermouseInfo from './SilvermouseInfo';
import '../../css/auth.css';
import { AppLogo } from '../Controls/AppLogo';
import { IsSoundmouse } from '../../tools/toolkit';
import Octicon, { getIconByName } from '@github/octicons-react'; //https://octicons.github.com/

class Gateway extends React.Component {

    componentWillMount() {
        if (this.props.location.redirectUri === undefined) {
            this.props.getGateway();
        }
            

        // TODO: This class contains duplications which isn't good.
        // I have a feeling that those components need to be structured differently.
        // I would imagine to have some helper compnents that build up the screens based on the state.
        
    }  

    render() {
        if (this.props.location.redirectUri)
            window.location = this.props.location.redirectUri;

        if (!this.props.hasErrorOccured && this.props.gatewayUri) {
            window.location = this.props.gatewayUri;
        }

        if (this.props.loggedOut === true) {
            return <SilvermouseInfo />;
        }

        if (this.props.hasErrorOccured)
            return this.props.errorData.message;

        return '';
    }
}

export default connect(
    state => state.gateway,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Gateway);


// WEBPACK FOOTER //
// ./src/components/Auth/Gateway.js